import React from 'react';

/**
 * İlgi alanı etiketi bileşeni
 * 
 * @param {Object} props - Bileşen özellikleri
 * @param {string} props.label - Etiket metni
 * @param {boolean} props.selected - Etiketin seçili olup olmadığı
 * @param {Function} props.onToggle - Etiket durumu değiştiğinde çağrılacak fonksiyon
 * @param {boolean} props.isCategory - Ana kategori etiketi mi?
 */
const InterestTag = ({ 
  label, 
  selected = false, 
  onToggle,
  isCategory = false
}) => {
  return (
    <button
      className={`px-3 py-1 rounded-full text-sm transition-colors ${
        selected
          ? 'bg-indigo-600 text-white'
          : 'bg-gray-100 text-gray-800 hover:bg-gray-200'
      } ${isCategory ? 'font-medium' : ''}`}
      onClick={onToggle}
    >
      {label}
    </button>
  );
};

export default InterestTag;
